import React, { FC, useState } from 'react';

import classNames from 'classnames';

import { IconProps } from '../../shared/ui';

export const WaIcon: FC<IconProps> = ({ width = 40, height = 40, fillBg = '#C00000', className, needHover = true }) => {
  const [hover, setHover] = useState(false);
  return (
    <svg
      onMouseMove={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={classNames(className, { 'cursor-pointer': needHover })}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="10" fill={hover && needHover ? '#111026' : fillBg} />
      <mask
        id="mask0_371_3149"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="18"
        height="18"
      >
        <path d="M11 11H28.9166V28.9166H11V11Z" fill="white" />
      </mask>
      <g mask="url(#mask0_371_3149)">
        <path
          d="M21.6462 11.1326L21.1087 11.0571C19.4933 10.8239 17.8449 11.0546 16.3557 11.7224C14.8664 12.3903 13.5977 13.4677 12.6974 14.829C11.7394 16.1303 11.1684 17.6756 11.05 19.2871C10.9315 20.8986 11.2705 22.5108 12.0278 23.9382C12.1054 24.0813 12.1536 24.2383 12.1698 24.4002C12.186 24.5621 12.1698 24.7256 12.1221 24.8812C11.7355 26.2108 11.3772 27.5498 11 28.9548L11.4715 28.8134C12.7445 28.4739 14.0175 28.1345 15.2906 27.8233C15.5592 27.7674 15.8385 27.7937 16.0921 27.8987C17.2342 28.4561 18.4824 28.7628 19.7528 28.7981C21.0232 28.8334 22.2864 28.5966 23.4578 28.1035C24.6291 27.6105 25.6815 26.8726 26.5441 25.9393C27.4068 25.0061 28.0599 23.8991 28.4596 22.6927C28.8592 21.4862 28.9962 20.2083 28.8613 18.9446C28.7264 17.6809 28.3228 16.4606 27.6775 15.3657C27.0322 14.2709 26.1601 13.3267 25.1199 12.5966C24.0796 11.8664 22.8953 11.3673 21.6462 11.1326ZM24.0225 23.5044C23.6798 23.8113 23.2619 24.0218 22.8113 24.1145C22.3608 24.2073 21.8937 24.179 21.4576 24.0325C19.4817 23.4761 17.7674 22.2363 16.6201 20.534C16.1819 19.932 15.8297 19.2718 15.5734 18.5727C15.4347 18.167 15.4097 17.731 15.5011 17.3121C15.5925 16.8932 15.7969 16.5073 16.0921 16.1963C16.2358 16.013 16.4314 15.8771 16.6534 15.8064C16.8754 15.7358 17.1136 15.7337 17.3368 15.8003C17.5254 15.8474 17.6574 16.1209 17.8272 16.3284C17.9648 16.7178 18.1261 17.0988 18.3081 17.4694C18.4462 17.6584 18.5038 17.8945 18.4685 18.1259C18.4332 18.3573 18.3077 18.5654 18.1195 18.7047C17.6951 19.0819 17.7612 19.393 18.0629 19.8174C18.73 20.7784 19.6505 21.5357 20.7221 22.0051C21.0239 22.1371 21.2502 22.1654 21.4482 21.8542C21.5331 21.7316 21.6462 21.6279 21.7405 21.5147C22.2874 20.8264 22.1177 20.8358 22.9853 21.213C23.2615 21.329 23.5294 21.4648 23.7868 21.6185C24.0414 21.7693 24.428 21.9297 24.4846 22.156C24.539 22.4015 24.5247 22.6573 24.4432 22.8952C24.3617 23.1331 24.2161 23.3439 24.0225 23.5044Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
